define('Magento_Checkout/js/model/shipping-save-processor/payload-extender',[], function () {
    'use strict';

    return function (payload) {
        payload.addressInformation['extension_attributes'] = {};

        return payload;
    };
});

